var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M8.024 8.632l6.612-6.733a.83.83 0 0 0 .237-.586.83.83 0 0 0-.237-.585l-.487-.496a.803.803 0 0 0-1.15 0L7.448 5.886 1.889.226a.8.8 0 0 0-1.15 0L.254.722a.83.83 0 0 0-.237.585c0 .222.084.43.237.585l6.618 6.74a.8.8 0 0 0 .576.241.8.8 0 0 0 .577-.241z"}));
}

Chevron.defaultProps = {"width":"15","height":"9","viewBox":"0 0 15 9"};

module.exports = Chevron;

Chevron.default = Chevron;
